export default {
  namespaced: true,
  state: () => ({
    searchQuery: undefined
  }),
  mutations: {
    RESET_SEARCH_QUERY(state) {
      state.searchQuery = undefined
    },
    SET_SEARCH_QUERY(state, value) {
      state.searchQuery = value
    }
  },
  getters: {
    searchQuery: state => state.searchQuery
  }
}